import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from "@mui/material";

import { TemporaryImage } from "../../componentsV2/image/TemporaryImage";
import { UploadStagingImageCarousel } from "../../componentsV2/image/UploadStagingImageCarousel";
import { isMobile } from "react-device-detect";
import { useSnackbar } from "notistack";
import { useState } from "react";

type CreateLocationDialogProps = {
    open: boolean;
    onClose: () => void;
    createLocation: (locationName: string, locationImages?: Blob[]) => (void | Promise<void>);
};

export const CreateLocationDialog = ({ open, onClose, createLocation }: CreateLocationDialogProps) => {
    const [locationName, setLocationName] = useState("");
    const [stagedImages, setStagedImages] = useState<Array<TemporaryImage>>([]);
    const snackbar = useSnackbar();

    const submitLocation = async () => {
        try {
            const trimmedLocationName = locationName.trim();
            await createLocation(trimmedLocationName, stagedImages.map(imageDTO => imageDTO.file));
            snackbar.enqueueSnackbar(`Location "${trimmedLocationName}" created successfully`, { variant: "success" });
        } catch (error) {
            snackbar.enqueueSnackbar("Failed to create location", { variant: "error" });
        } finally {
            closeDialog();
        }
    };

    const closeDialog = () => {
        onClose();
        setLocationName("");
        setStagedImages([]);
    };

    return (
        <Dialog
            open={open}
            onClose={closeDialog}
            fullWidth
            maxWidth="sm"
            fullScreen={isMobile}
        >
            <DialogTitle>Add a New Location</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Location Name"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={locationName}
                    onChange={(e) => setLocationName(e.target.value)}
                    required
                />
                <Box
                    mt={2}
                    sx={{
                        aspectRatio: "16/9",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <UploadStagingImageCarousel
                        imageDTOs={stagedImages}
                        setImageDTOs={setStagedImages}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={closeDialog}
                    variant="outlined"
                    color="error"
                >
                    Cancel
                </Button>
                <Button
                    onClick={submitLocation}
                    variant="contained"
                    disabled={!locationName.trim()}
                >
                    Add Location
                </Button>
            </DialogActions>
        </Dialog>
    );
};